/**
 * Lưu `AppSettings` vào store `settings` của IndexedDB — Prompt.md §27.
 *
 * Cùng một database với session (không thêm `localStorage`): §7 nói rõ mọi dữ liệu nằm trên thiết
 * bị, và có hai nơi lưu nghĩa là có hai nơi phải xoá khi người dùng bấm "xoá toàn bộ dữ liệu" —
 * cái thứ hai sẽ là cái bị quên.
 *
 * Mọi lỗi bị nuốt: không lưu được cài đặt là bất tiện, còn để nó throw ra sẽ chặn cả app khởi
 * động trên Safari private mode.
 */

import { normalizeSettings, type AppSettings } from "../../app/settings.js";
import { openStudyStraightDB, type StudyStraightDatabase } from "./db.js";

const SETTINGS_KEY = "app";

export interface SettingsStore {
  load: () => Promise<AppSettings>;
  save: (settings: AppSettings) => Promise<void>;
}

export function createSettingsStore(): SettingsStore {
  // Mở một lần rồi dùng lại: `openDB` mỗi lần save (người dùng kéo slider ngưỡng ở Developer
  // section là nhiều lần liên tiếp) sẽ tạo hàng chục connection.
  let opening: Promise<StudyStraightDatabase> | null = null;
  const db = async (): Promise<StudyStraightDatabase> => {
    opening ??= openStudyStraightDB();
    return opening;
  };

  return {
    async load() {
      try {
        return normalizeSettings(await (await db()).get("settings", SETTINGS_KEY));
      } catch {
        return normalizeSettings(undefined);
      }
    },
    async save(settings) {
      try {
        // Ghi bản sao thuần: object của React state có thể đang bị Proxy/frozen tuỳ dev tool, và
        // structured clone của IndexedDB sẽ throw thay vì lưu.
        await (await db()).put("settings", JSON.parse(JSON.stringify(settings)), SETTINGS_KEY);
      } catch {
        // Xem comment đầu file.
      }
    },
  };
}
